<template>
  <b-modal v-model="modalValue" :can-cancel="false" :width="1280">
    <div class="modal-content">
      <div class="modal-header">
        <p class="averta-bold label-18">Riwayat Reschedule</p>
        <div class="is-clickable" @click="closeModal">
          <XMarkIcon color="#000000" />
        </div>
      </div>
      <b-loading :is-full-page="isFullPage" v-model="isLoading" :can-cancel="false">
        <SpinnerIcon />
      </b-loading>
      <div class="modal-body">
        <div class="content-modal-body gap-3">
          <div v-if="dataHistoryReschedule.length === 0 && !isLoading" class="c-w-100">
            <div class="columns is-centered">
              <div class="column has-text-centered">
                <ProyekEmptyIcon />
                <p class="averta-bold">Tidak Ada Riwayat Reschedule</p>
              </div>
            </div>
          </div>

          <div
            v-if="dataHistoryReschedule.length > 0 && !isLoading"
            class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center"
          >
            <p class="averta-bold label-16 color-blue-1">
              Tanggal Awal:
              {{
                convertDate(
                  dataHistoryReschedule &&
                    dataHistoryReschedule[dataHistoryReschedule.length - 1].original_date
                )
              }}
              {{
                dataHistoryReschedule[dataHistoryReschedule.length - 1].original_start_time
                  ? `(${
                      dataHistoryReschedule[dataHistoryReschedule.length - 1].original_start_time
                    })`
                  : ''
              }}
            </p>
          </div>

          <div
            v-if="dataHistoryReschedule.length > 0 && !isLoading"
            class="is-flex is-flex-direction-row is-justify-content-flex-center is-align-items-center c-w-100"
          >
            <!-- Content Table -->
            <div class="content-table-history">
              <div class="header-table-history">
                <div class="row-content-table-history">
                  <div class="data-table-history">
                    <p class="averta-bold label-14 color-white">Tanggal Permintaan</p>
                  </div>
                  <div class="data-table-history">
                    <p class="averta-bold label-14 color-white">Nama</p>
                  </div>
                  <div class="data-table-history">
                    <p class="averta-bold label-14 color-white">Tanggal Baru</p>
                  </div>
                  <div class="data-table-history">
                    <p class="averta-bold label-14 color-white">Catatan</p>
                  </div>
                  <div class="data-table-history">
                    <p class="averta-bold label-14 color-white">Status</p>
                  </div>
                </div>
              </div>
              <div class="body-table-history">
                <div
                  v-for="(dataHistory, indexHistory) in dataHistoryReschedule"
                  :key="`${indexHistory}-history`"
                  class="row-content-table-history"
                  style="border-bottom: 1px solid #e1e1e1; background: #ffffff"
                >
                  <div class="data-table-history">
                    <p class="averta-regular label-14 color-black has-text-centered">
                      {{
                        dataHistory.created_at
                          ? moment(dataHistory.created_at).format('dddd, DD MMMM YYYY (HH:mm)')
                          : ''
                      }}
                    </p>
                  </div>
                  <div class="data-table-history">
                    <p class="averta-regular label-14 color-black has-text-centered">
                      {{ dataHistory.created_by_name }}
                    </p>
                  </div>
                  <div class="data-table-history">
                    <p class="averta-regular label-14 color-black has-text-centered">
                      {{ convertDate(dataHistory.actually_date || dataHistory.date) }}
                      {{ dataHistory.start_time ? `(${dataHistory.start_time})` : '' }}
                    </p>
                  </div>
                  <div class="data-table-history">
                    <b-tooltip
                      v-if="dataHistory.reason"
                      :label="dataHistory.reason"
                      position="is-left"
                      size="is-large"
                      multilined
                      type="is-black"
                      class="tooltip-table-history-reason"
                    >
                      <p
                        class="averta-regular label-14 color-black has-text-centered c-w-100 c-h-100"
                      >
                        {{ safeSubstring(dataHistory.reason, 65) || '-' }}
                      </p>
                    </b-tooltip>
                    <div
                      v-else
                      class="is-flex is-flex-direction-row is-justify-content-center is-align-items-center c-w-100 c-h-100"
                    >
                      <p class="averta-regular is-font-14 black-color has-text-centered">-</p>
                    </div>
                  </div>
                  <div class="data-table-history">
                    <span
                      class="badge-status"
                      :class="`wrap-status has-text-white px-4 py-2 ${statusReschedule(
                        dataHistory.status
                      )}`"
                    >
                      <p
                        class="averta-regular label-14 color-white has-text-centered"
                        style="white-space: nowrap"
                      >
                        {{ statusReschedule(dataHistory.status, true) }}
                      </p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Content Table -->
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <ButtonApp width="200px" height="35px" :isSecondary="true" @click="closeModal">
          <p class="averta-reguler label-16">Tutup</p>
        </ButtonApp>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { XMarkIcon, ProyekEmptyIcon, SpinnerIcon } from '@/components/icons'
import { mapGetters } from 'vuex'
import ButtonApp from '@/components/button/ButtonApp.vue'
import moment from 'moment'

export default {
  name: 'ModalTableHistoryReschedule',
  props: {
    isOpenModal: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      dataHistoryReschedule: [],
      isLoading: false,
      isFullPage: false,
      moment: moment
    }
  },
  components: {
    XMarkIcon,
    ButtonApp,
    ProyekEmptyIcon,
    SpinnerIcon
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      user: 'auth/user'
    }),
    modalValue: {
      get () {
        return this.isOpenModal
      },
      set (value) {
        this.$emit('update:isOpenModal', value)
      }
    }
  },
  methods: {
    closeModal () {
      this.$emit('closeModal', false)
    },
    getHistoryReschedule () {
      this.isLoading = true
      const payload = {
        url: this.url,
        survey_id: this.data.survey_id
      }

      this.$store
        .dispatch('project/getHistoryReschedule', payload)
        .then((res) => {
          this.dataHistoryReschedule = res.data.data
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          console.log(error)
          this.$buefy.toast.open({
            message:
              '<p class="averta-regular">Gagal Memuat Data Riwayat Reschedule, silahkan coba lagi</p>',
            type: 'is-danger'
          })
        })
    },
    convertDate (date) {
      if (!date) {
        return ''
      }
      return moment(date).format('dddd, DD MMMM YYYY')
    },
    statusReschedule (val, name) {
      switch (val) {
        case 'approve':
          return name ? 'Disetujui' : 'bg-green-2'
        case 'reject':
          return name ? 'Ditolak' : 'bg-red'
        case 'pending':
          return name ? 'Dalam Proses' : 'bg-dark-yellow'
        case 'cancel':
          return name ? 'Dibatalkan' : 'bg-dark-grey-4'
        default:
          return name || 'bg-dark-grey-4'
      }
    },
    safeSubstring (text, maxLength) {
      if (!text) return '-'
      if (text.length <= maxLength) return text

      const trimmed = text.substring(0, maxLength)
      const lastSpaceIndex = trimmed.lastIndexOf(' ')

      if (lastSpaceIndex === -1) return '-'

      return trimmed.substring(0, lastSpaceIndex) + '...'
    }
  }
}
</script>

<style scoped>
.modal-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 500px;
  max-height: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0;

  background: transparent;
}

.modal-header {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 65px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 1.5rem;
  background: #fafafa;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.modal-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 500px;
  max-height: 100%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 2rem;

  background: #ffffff;
}

.content-modal-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 100px;
  max-height: 800px;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 auto;
  padding: 2rem;

  background: #fbfdff;
  border: 1px solid #e1e1e1;
  border-radius: 20px;
}

.content-table-history {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 70px;
  max-height: 800px;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0;

  background: transparent;
}

.header-table-history {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 70px;
  min-height: 70px;
  max-height: 70px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0;

  background: #868686;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.body-table-history {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 70px;
  max-height: 500px;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0;
  background: transparent;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border: 1px solid #e1e1e1;
  overflow: auto !important;
}

.body-table-history::-webkit-scrollbar {
  display: none;
}

.body-table-history {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.row-content-table-history {
  display: flex;
  flex: 1;
  flex-direction: row;
  width: 100%;
  height: 70px;
  min-height: 70px;
  max-height: 70px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  background: transparent;
}

.row-content-table-history:last-child {
  border-bottom: none !important;
}

.data-table-history {
  display: flex;
  flex: 1;
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  background: transparent;
}

.modal-footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 65px;
  justify-content: flex-end;
  align-items: center;
  margin: 0 auto;
  padding: 0 1.5rem;
  border-top: 1px solid #e1e1e1;
  background: #ffffff;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.badge-status {
  display: flex;
  flex-direction: row;
  width: auto;
  max-width: 100%;
  height: 30px;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0 0.85rem;
  background: #10bd41;
  border-radius: 100px;
}
</style>

<style>
.tooltip-table-history-reason.b-tooltip.is-multiline.is-large .tooltip-content {
  width: 600px;
}
</style>
